module.exports = __webpack_public_path__ + "static/media/3.851aaa06.jpg";